import { render, staticRenderFns } from "./FarmersList.vue?vue&type=template&id=f711f404&scoped=true&"
import script from "./FarmersList.vue?vue&type=script&lang=js&"
export * from "./FarmersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f711f404",
  null
  
)

export default component.exports